var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackMoreBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20C0.5 8.95431 9.45431 0 20.5 0C31.5457 0 40.5 8.95431 40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.5 20Z",
    fill: "url(#paint0_linear_26951_20920)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26951_20920)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 13.1429C14.2909 13.1429 12.5 14.9337 12.5 17.1429V25.1429C12.5 25.5975 12.6806 26.0336 13.0021 26.3551C13.3236 26.6766 13.7596 26.8571 14.2143 26.8571H25.0714C25.5261 26.8571 25.9622 26.6766 26.2837 26.3551C26.6051 26.0336 26.7857 25.5975 26.7857 25.1429V24.5714H23.9286C22.824 24.5714 21.9286 23.676 21.9286 22.5714V20.8571C21.9286 19.7526 22.824 18.8571 23.9286 18.8571H26.7857V18.2857C26.7857 17.831 26.6051 17.395 26.2837 17.0735C25.9622 16.752 25.5261 16.5714 25.0714 16.5714H17.0714C16.6769 16.5714 16.3571 16.2516 16.3571 15.8571C16.3571 15.4626 16.6769 15.1429 17.0714 15.1429H24.5V13.7143C24.5 13.3987 24.2441 13.1429 23.9286 13.1429H16.5ZM23.9286 20.2857H27.9286C28.2441 20.2857 28.5 20.5416 28.5 20.8571V22.5714C28.5 22.887 28.2441 23.1429 27.9286 23.1429H23.9286C23.613 23.1429 23.3571 22.887 23.3571 22.5714V20.8571C23.3571 20.5416 23.613 20.2857 23.9286 20.2857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26951_20920",
    x1: 30.2222,
    y1: 4.44444,
    x2: 4.66667,
    y2: 67.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26951_20920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackMoreBank);
export default __webpack_public_path__ + "static/media/stack_more_bank.d0fe453dbeabd61614f800f68ef9f5f0.svg";
export { ForwardRef as ReactComponent };